import { ExamOverviewType } from '../../api/exam';
import Segment from '../shared/segment';
import Field from '../shared/field';
import { useBooleanState } from '../../hooks/index/use-boolean-state';
import classNames from 'classnames';
import { ReactNode } from 'react';

export type ExamHeaderPropsType = {
  exam: ExamOverviewType;
  timer: ReactNode;
};

function ExamHeader({ exam, timer }: ExamHeaderPropsType) {
  const { value: showMore, toggle: toggleShowMore } = useBooleanState(false);

  return (
    <Segment bg noMargin color='green' className='sticky top-1 grid gap-2 md:grid-cols-3'>
      <Field title='نام آزمون' content={exam.name} className='md:col-span-2' />
      {timer}
      <Field
        title='زمان آزمون'
        content={`${exam.duration} دقیقه`}
        className={classNames({ 'hidden md:block': !showMore })}
      />
      <Field
        title='تعداد سوالات'
        content={exam.questionCount}
        className={classNames({ 'hidden md:block': !showMore })}
      />
      <Field
        title='نمره منفی'
        content={exam.penalty ? 'دارد' : 'ندارد'}
        className={classNames({ 'hidden md:block': !showMore })}
      />
      <div className='mx-auto md:hidden'>
        <button onClick={toggleShowMore}>...</button>
      </div>
    </Segment>
  );
}

export default ExamHeader;
